<template>
  <div class="flex flex-wrap gap-1 xl:gap-2">
    <Button
      label="Registrid"
      icon="pi pi-chevron-down"
      icon-pos="right"
      data-testid="register-links-trigger"
      class="w-full justify-between border-green-400 bg-green-100 text-green-600 hover:bg-green-200 md:w-56"
      aria-haspopup="true"
      aria-controls="register-links-menu"
      @click="menu.toggle($event)"
      />
    <Menu id="register-links-menu" ref="menu" :model="items" popup>
      <template #item="{ item, props: itemProps }">
        <a
          v-if="item.url"
          v-bind="itemProps.action"
          :href="item.url"
          target="_blank"
          rel="noopener noreferrer"
          :data-testid="`register-link-${item.key}`"
          >
          <span>{{ item.label }}</span>
          <span class="ml-auto text-xs text-gray-500">↗</span>
        </a>
        <span
          v-else
          v-bind="itemProps.action"
          class="text-gray-400"
          :data-testid="`register-link-${item.key}`"
          >
          <span>{{ item.label }}</span>
        </span>
      </template>
    </Menu>
  </div>
</template>

<script setup>
import { computed, useTemplateRef } from 'vue'
import { useI18n } from 'vue-i18n'
import { DETAIL_EXTERNAL_LINKS } from '../../../constants'
import { formatLink } from '../../../services/utilities'

const props = defineProps({
  cadasterId: { type: String, default: '' },
  ehrId: { type: String, default: '' },
})

const { t } = useI18n()
const menu = useTemplateRef('menu')

const items = computed(() =>
  Object.keys(DETAIL_EXTERNAL_LINKS).map(key => {
    const isCadaster = DETAIL_EXTERNAL_LINKS[key].includes('${cadasterId}')
    const isEhr = DETAIL_EXTERNAL_LINKS[key].includes('${ehrId}')
    const enabled = (isCadaster && props.cadasterId) || (isEhr && props.ehrId)

    return {
      key,
      label: t(`messages.detail.${key}`),
      url: enabled
        ? formatLink(DETAIL_EXTERNAL_LINKS[key], {
            cadasterId: props.cadasterId,
            ehrId: props.ehrId,
          })
        : undefined,
      disabled: !enabled,
    }
  }),
)
</script>
